import { SWRConfiguration, mutate } from 'swr';

import { FetcherParams } from '@/data/fetcher';
import { UseSWRMutationOptions, useSWR, useSWRMutation } from '@/hooks/useSwr';
import { getPromptCanvasPath } from '@/utils/constants';

export type TCanvasQuickAction = {
  id: string;
  tenant_id: string;
  name: string;
  prompt: string;
  description?: string;
  icon?: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
};

type CreateQuickActionPayload = {
  name: string;
  prompt: string;
  description?: string;
};

type DeleteQuickActionPayload = {
  id: string;
};

type UpdateQuickActionPayload = {
  id: string;
  name: string;
  prompt: string;
  description?: string;
};

export enum ECreateActionModalState {
  CREATE = 'create',
  EDIT = 'edit',
}

export const useCanvasQuickActions = (options?: SWRConfiguration) => {
  return useSWR<TCanvasQuickAction[]>(
    { url: getPromptCanvasPath('quick-action') },
    options
  );
};

export const useCreateCanvasQuickAction = (
  options?: UseSWRMutationOptions<TCanvasQuickAction, CreateQuickActionPayload>
) => {
  return useSWRMutation<TCanvasQuickAction, CreateQuickActionPayload>(
    { url: getPromptCanvasPath('quick-action'), method: 'POST' },
    {
      onSuccess: () => {
        mutate((key: FetcherParams) =>
          key?.url?.startsWith(getPromptCanvasPath('quick-action'))
        );
      },
      ...options,
    }
  );
};
export const useDeleteCanvasQuickAction = (
  options?: UseSWRMutationOptions<TCanvasQuickAction, DeleteQuickActionPayload>
) => {
  return useSWRMutation<TCanvasQuickAction, DeleteQuickActionPayload>(
    { url: getPromptCanvasPath('quick-action'), method: 'DELETE' },
    {
      onSuccess: () => {
        mutate((key: FetcherParams) =>
          key?.url?.startsWith(getPromptCanvasPath('quick-action'))
        );
      },
      ...options,
    }
  );
};

export const useUpdateCanvasQuickAction = (
  options?: UseSWRMutationOptions<TCanvasQuickAction, UpdateQuickActionPayload>
) => {
  return useSWRMutation<TCanvasQuickAction, UpdateQuickActionPayload>(
    { url: getPromptCanvasPath('quick-action'), method: 'PATCH' },
    {
      onSuccess: () => {
        mutate((key: FetcherParams) =>
          key?.url?.startsWith(getPromptCanvasPath('quick-action'))
        );
      },
      ...options,
    }
  );
};
